module.exports = __webpack_public_path__ + "static/media/general-credit-card.8d26aaa5.svg";